define.alias("shared/components/shared/ui/switcher/option", "media/components/shared/ui/switcher/option");